import { Stars } from '#src/components/card/StarRank/index.tsx';

type Props = { dropRank: number };

const MAX_STARS = 5;

export const DropRank = ({ dropRank }: Props) => {
  const starCount = Math.abs(dropRank - 6);
  const count = Math.min(starCount, MAX_STARS);
  const sparkles = starCount === 6;

  return <Stars count={count} sparkles={sparkles} />;
};
